import './OrderRepresentativeNotes.scss';
import Component from './OrderRepresentativeNotes.js';
export default Component;
